import { PUBLIC_ROUTES, PUBLIC_URL_PREFIXES } from 'constants/publicPaths';

const PUBLIC_EXACT_PATHS = new Set(Object.values(PUBLIC_ROUTES) as string[]);

const isUnderDeclaredPublicPrefix = (pathname: string): boolean =>
  PUBLIC_URL_PREFIXES.some((prefix) => pathname.startsWith(`${prefix}/`));

/**
 * Ruta pública si coincide con un path registrado en `PUBLIC_ROUTES`
 * o si cae bajo algún prefijo listado en `PUBLIC_URL_PREFIXES` (subrutas / 404 de zona).
 */
export const isPublicRoute = (pathname: string): boolean => {
  if (PUBLIC_EXACT_PATHS.has(pathname)) return true;
  return isUnderDeclaredPublicPrefix(pathname);
};
